import {
  Avatar,
  ButtonBase,
  Divider,
  Modal,
  Stack,
  Typography,
} from '@mui/material';
import { TextBody } from './TextBody';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { CheckboxInput } from 'Components/CheckboxInput';
import { useEffect, useRef, useState } from 'react';
import { HandHoldingHeartIcon, PurpleClose } from 'Images';
import { useDictionary, useIsDesktop } from 'Hooks';
import { UserApproval } from './UserApproval';
import { useNavigate } from 'react-router-dom';

interface IAgreementModal {
  setModalAgreementBox: Function;
}

export const AgreementModal = ({ setModalAgreementBox }: IAgreementModal) => {
  const isDesktop = useIsDesktop();
  const [open, setOpen] = useState(true);

  const dictionary = useDictionary(
    Dictionary,
    DICTIONARY.CompassRights
  ).agreementModal;

  const modalRef = useRef<any>(null);
  const [checked, setChecked] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (modalRef && modalRef.current) modalRef.current.focus();
  }, []);

  return (
    <Modal
      ref={modalRef}
      open={open}
      BackdropProps={{
        sx: {
          bgColor: 'rgba(8, 30, 84, .8)',
        },
      }}
      sx={{
        zIndex: 5000,
        direction: 'ltr',
        overflow: 'scroll',
      }}
    >
      <Stack
        bgcolor={'primary.shade_100'}
        borderRadius={isDesktop ? '20px' : '16px'}
        maxWidth={isDesktop ? '770px' : '330px'}
        padding={isDesktop ? '48px 24px 40px 24px' : '64px 20px 16px 20px'}
        position={'absolute'}
        top={isDesktop ? '50%' : '70%'}
        left={'50%'}
        textAlign={isDesktop ? undefined : 'center'}
        sx={{
          transform: 'translate(-50%, -50%)',
        }}
      >
        <ButtonBase
          onClick={() => navigate('/')}
          sx={{ position: 'absolute', right: '20px', top: '20px' }}
        >
          <Avatar
            alt={dictionary.closeModal}
            src={PurpleClose}
            sx={{
              width: '40px',
              height: '40px',
            }}
          />
        </ButtonBase>
        <Stack gap={isDesktop ? '64px' : '0'} alignItems={'center'}>
          <Stack alignItems={'center'} gap={isDesktop ? '4px' : '16px'}>
            <Avatar
              src={HandHoldingHeartIcon}
              alt={''}
              sx={{
                width: isDesktop ? '120px' : '90px',
                height: isDesktop ? '120px' : '90px',
              }}
            />
            <Stack gap={isDesktop ? '32px' : '24px'}>
              <TextBody />
              <CheckboxInput
                checked={checked}
                label={dictionary.checkboxLabel}
                onChange={() => setChecked(!checked)}
                containerStyle={{
                  '.MuiCheckbox-root': {
                    padding: 0,
                  },
                }}
              />
              {errorMessage && (
                <Typography
                  color='#d90000'
                  fontSize='11px'
                  textAlign='center'
                  fontWeight={700}
                  zIndex={10}
                  aria-live='assertive'
                >
                  {dictionary.errorMsg}
                </Typography>
              )}
            </Stack>
          </Stack>
          {!isDesktop && (
            <Divider
              aria-hidden={'true'}
              orientation={'horizontal'}
              sx={{
                borderColor: 'primary.shade_100',
                margin: '24px 0',
              }}
            />
          )}
          <UserApproval
            setModalAgreementBox={setModalAgreementBox}
            userAgreement={checked}
            setShowAgreementErrorMessage={setErrorMessage}
            modalRef={modalRef}
          />
        </Stack>
      </Stack>
    </Modal>
  );
};
